import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Router } from '@angular/router';
import { User } from '../models/user';
import { EMPTY, Observable, Subscription, first, map, switchMap, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonService } from '../services/common.service';
import { DeviceScreenComponent } from '../control/device-control/device-screen/device-screen.component';
import { StackService } from '../services/stack-service.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BrowserDataService } from '../services/browser-data.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';



@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, RouterModule]
})
export class MenuComponent implements OnInit {
  currentActiveTab: string = '/devices';
  private activeTabSubscription: Subscription;
  browserDetails: any[] = [];
  modalRef!: MatDialogRef<any>;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  msg: string = "";
  stack: any;
  patil: any
  userUsing: any
  currentUser: any;
  serial: String;
  private baseUrl: any = environment.baseUrl;
  private baseUrlBrowser: any = environment.baseUrlBrowser;
  menuItems = [{ label: 'Control', iconClass: 'fa fa-mobile', tabRoute: '/control/' },
  { label: 'Inspector', iconClass: 'fa fa-binoculars', tabRoute: '/inspector/' },
  { label: "Devices", iconClass: 'fa fa-sitemap', tabRoute: '/devices' },
  { label: 'Webscreen', iconClass: 'fa fa-desktop', tabRoute: '/webscreen/' },
  { label: 'Browser', iconClass: 'fa fa-window-restore', tabRoute: '/browser' },
  { label: 'User Profile', iconClass: 'fa fa-user', tabRoute: '/user' },
  // { label: 'Reports', iconClass: 'fa fa-newspaper-o', tabRoute: '/report' },
  { label: 'Settings', iconClass: 'fa fa-gears', tabRoute: '/settings' },
  ];

  displayObservable$: Observable<any>;

  constructor(
    private dataService: BrowserDataService,
    private http: HttpClient,
    private router: Router,
    private loginService: LoginService,
    private commonService: CommonService,
    private stackService: StackService,
    private dialog: MatDialog,
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit(): void {
    this.activeTabSubscription = this.commonService.currentActiveTab$.subscribe(
      (activeTab: string) => {
        this.currentActiveTab = activeTab;
        console.log('Current active tab in menu:', this.currentActiveTab);
      }
    );
    this.setActiveTabFromRoute(window.location.href);
    //   this.http.get(`${this.baseUrl}` + '/api/v1/devices').subscribe((response: any) => {


    // setInterval(() => {
    //   this.userUsing=localStorage.getItem('userUsing')

    // }, 2000);


    this.userUsing = localStorage.getItem('userUsing')

    //   this.http.get(`${this.baseUrl}` + '/api/v1/devices').subscribe((response: any) => {
    //     response.devices.forEach((device: any) => {
    //         if(device.using)
    //         {
    //            this.serial=device.serial;
    //         }
    //     });
    // })
  }

  private setActiveTabFromRoute(url: string): void {
    // Remove query params and fragments
    // const baseUrl = url.split('#')[1].split('/')[1].split('/')[0];

    // Find matching menu item
    const matchingMenuItem = this.menuItems.find(item => url.includes(item.tabRoute));
    console.log('matchingmenuitem: ', matchingMenuItem);

    if (matchingMenuItem) {
      const activeRoute = matchingMenuItem.tabRoute;
      this.commonService.setActiveTab(activeRoute);
    } else {
      // Default to /devices if no match found
      this.commonService.setActiveTab('/devices');
    }
  }

  mailToProteanSupport() {
    let mail = 'mailto:admin@apmosys.com';
    window.location.href = mail;
  }
  logout() {
    const loginMethod = localStorage.getItem('loginMethod');

    this.deleteCookie('XSRF-TOKEN');
    this.deleteCookie('SSID');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    localStorage.removeItem('loginMethod');
    sessionStorage.removeItem('currentUser');
    localStorage.setItem('logoutEvent', Date.now().toString());

    this.loginService.setcurrentUserSubject(null);

    if (loginMethod === 'saml') {
      window.location.href = `${this.baseUrl}/auth/saml/logout`;
    } else {
      this.router.navigate(['/login']);
    }
  }
  private deleteCookie(name: string) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Strict';
  }

  onTabClick(tabRoute: any) {
    switch (tabRoute) {
      // case '/inspector/': {
      //   let data = sessionStorage.getItem("payloadAppiumSession");
      //   let payloadAppiumSession = data ? JSON.parse(data) : null;
      //   // console.log('\ndevice serial:', payloadAppiumSession?.desiredCapabilities["appium:deviceName"]);

      //   if (!payloadAppiumSession) {
      //     this.msg = "Please create an Appium session first from Control tab!";
      //     this.openAlertMod(this.alertTemplate, this.msg);
      //     this.router.navigate([this.commonService.getCurrentActiveTab()]);
      //     return;
      //   } else {
      //     let sessionId = sessionStorage.getItem("appiumSessionId");
      //     //checking if already there is a session saved in session storage of the browser.
      //     if (sessionId) {
      //       this.commonService.setActiveTab('/inspector/');
      //       this.router.navigate(['/inspector', sessionId]);
      //       return;
      //     } else {
      //       let providerUrl = sessionStorage.getItem('providerUrl');
      //       console.log('providerUrl before the request of session in menu component: ', providerUrl);

      //       this.http.post(providerUrl + '/session', payloadAppiumSession).subscribe((response: any) => {
      //         console.log("Appium Session Created: ", response);
      //         if (response.value && response.value.sessionId) {
      //           sessionStorage.setItem("appiumSessionId", response.value.sessionId);
      //           this.commonService.setActiveTab('/inspector/');
      //           this.router.navigate(['/inspector', response.value.sessionId]);
      //         }
      //         else {
      //           this.msg = response.value.message || "Failed to create Appium session. Please try again.";
      //           this.openAlertMod(this.alertTemplate, this.msg);
      //           this.router.navigate([this.commonService.getCurrentActiveTab()]);
      //         }
      //       });
      //     }
      //   }
      //   break;
      // }
      case '/inspector/': {
        let data = sessionStorage.getItem("payloadAppiumSession");
        let payloadAppiumSession = data ? JSON.parse(data) : null;

        if (!payloadAppiumSession) {
          this.msg = "Please create an Appium session first from Control tab!";
          this.openAlertMod(this.alertTemplate, this.msg);
          this.router.navigate([this.commonService.getCurrentActiveTab()]);
          return;
        }

        let providerUrl = JSON.parse(sessionStorage.getItem('device'))?.providerUrl;
        let sessionId = sessionStorage.getItem("appiumSessionId");
        let serial = payloadAppiumSession?.desiredCapabilities?.["appium:deviceName"]
          ?? payloadAppiumSession?.desiredCapabilities?.["appium:udid"];
        if (!serial) {
          serial = JSON.parse(sessionStorage.getItem("device"))?.serial;
        }

        if (sessionId && providerUrl) {
          // Validate existing session
          this.http.get(`${providerUrl}/session/${sessionId}`, { observe: 'response' }).subscribe({
            next: (response: any) => {
              if (response.status === 200) {
                // Session is still valid — navigate directly
                this.commonService.setActiveTab('/inspector/');
                this.router.navigate(['/inspector', serial, sessionId]);
              }
            },
            error: (error: any) => {
              // Session is invalid/expired — create a new one
              const errorValue = error?.error?.value;
              console.warn('Existing session invalid:', errorValue?.message);
              this.msg = "Existing session invalid. Please create a new Appium session from Control tab!";
              this.openAlertMod(this.alertTemplate, this.msg);
              if (this.commonService.getCurrentActiveTab() !== '/control/') {
                this.router.navigate([this.commonService.getCurrentActiveTab()]);
              } else {
                this.commonService.setActiveTab('/control/');
                this.router.navigate(['/control', serial]);
              }
            }
          });
        } else {
          // No session in storage — create a new one
          this.msg = "No session found. Please create an Appium session first from Control tab!";
          this.openAlertMod(this.alertTemplate, this.msg);
          if (this.commonService.getCurrentActiveTab() !== '/control/') {
            this.router.navigate([this.commonService.getCurrentActiveTab()]);
          } else {
            this.commonService.setActiveTab('/control/');
            this.router.navigate(['/control', serial]);
          }
        }
        break;
      }
      case '/webscreen/': {
        let user: any = JSON.parse(localStorage.getItem('currentUser'));
        this.http.post(`${this.baseUrlBrowser}` + '/getBrowserByUser', user).subscribe((response: any) => {
          if (response.success) {
            this.commonService.setActiveTab('/webscreen/');
            this.router.navigate(['/webscreen', response.id]);
          } else {
            this.msg = "Please select a Browser!";
            this.openAlertMod(this.alertTemplate, this.msg)
          }
        });
        break;
      }
      case '/control/': {
        this.http.get(`${this.baseUrl}` + '/api/v1/devices').subscribe((response: any) => {
          response.devices.forEach((device: any) => {
            if (tabRoute.includes("/control")) {
              if (device.using == true && device.present == true) {
                this.stackService.currentStack.subscribe(stack => {
                  this.stack = stack;
                });
                this.commonService.setActiveTab('/control/');
                this.router.navigate(['/control', this.stack[this.stack.length - 1]]);
              }
            }
            // }
            // if(device.using && device.present)
            // {
            //    this.serial=device.serial;
            // }
          });
        })
        this.commonService.getDataObject().subscribe((data: any) => {
          this.userUsing = data
        })
        let controlTab = tabRoute.includes("/control")
        if (controlTab) {
          if (this.userUsing < 1) {
            this.msg = "Please Select a Device!";
            this.openAlertMod(this.alertTemplate, this.msg);
            // alert("Please Select Device")
            // this.router.navigate(['/devices']);
          }
        }
        break;
      }
      default: {
        this.commonService.setActiveTab(tabRoute);
        this.router.navigate([tabRoute]);
        break;
      }
    }
  }

  // onTabClick(tabRoute: any) {
  //   //for routing to inspector tab
  //   if (tabRoute == "/inspector/") {
  //     let data = sessionStorage.getItem("payloadAppiumSession");
  //     let payloadAppiumSession = data ? JSON.parse(data) : null;
  //     // console.log('\ndevice serial:', payloadAppiumSession?.desiredCapabilities["appium:deviceName"]);

  //     if (!payloadAppiumSession) {
  //       this.msg = "Please create an Appium session first from Control tab!";
  //       this.openAlertMod(this.alertTemplate, this.msg);
  //       return;
  //     } else {
  //       let sessionId = sessionStorage.getItem("appiumSessionId");
  //       //checking if already there is a session saved in session storage of the browser.
  //       if (sessionId) {
  //         this.router.navigate(['/inspector', sessionId]);
  //         return;
  //       } else {
  //         let providerUrl = sessionStorage.getItem('providerUrl');
  //         console.log('providerUrl before the request of session in menu component: ', providerUrl);

  //         this.http.post(providerUrl + '/session', payloadAppiumSession).subscribe((response: any) => {
  //           console.log("Appium Session Created: ", response);
  //           if (response.value && response.value.sessionId) {
  //             sessionStorage.setItem("appiumSessionId", response.value.sessionId);
  //             this.router.navigate(['/inspector', response.value.sessionId]);
  //           }
  //           else {
  //             this.msg = response.value.message || "Failed to create Appium session. Please try again.";
  //             this.openAlertMod(this.alertTemplate, this.msg);
  //           }
  //         });
  //       }
  //     }
  //   }
  //   //for webscreen routing
  //   if (tabRoute == "/webscreen/") {
  //     let user: any = JSON.parse(localStorage.getItem('currentUser'));
  //     this.http.post(`${this.baseUrlBrowser}` + '/getBrowserByUser', user).subscribe((response: any) => {
  //       if (response.success) {
  //         this.router.navigate(['/webscreen', response.id]);
  //       } else {
  //         this.msg = "Please select a Browser!";
  //         this.openAlertMod(this.alertTemplate, this.msg)
  //       }
  //     });
  //   }

  //   this.http.get(`${this.baseUrl}` + '/api/v1/devices').subscribe((response: any) => {
  //     response.devices.forEach((device: any) => {
  //       if (tabRoute.includes("/control")) {
  //         if (device.using == true && device.present == true) {
  //           this.stackService.currentStack.subscribe(stack => {
  //             this.stack = stack;
  //           });
  //           this.router.navigate(['/control', this.stack[this.stack.length - 1]]);
  //         }
  //       }
  //       // }
  //       // if(device.using && device.present)
  //       // {
  //       //    this.serial=device.serial;
  //       // }
  //     });
  //   })
  //   this.commonService.getDataObject().subscribe((data: any) => {
  //     this.userUsing = data
  //   })
  //   let controlTab = tabRoute.includes("/control")
  //   if (controlTab) {
  //     if (this.userUsing < 1) {
  //       this.msg = "Please Select a Device!";
  //       this.openAlertMod(this.alertTemplate, this.msg);
  //       // alert("Please Select Device")
  //       // this.router.navigate(['/devices']);
  //     }
  //   }
  // }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }

}
